import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Stack,
  TextField,
} from '@mui/material';
import { useFormik } from 'formik';
import React from 'react';
import { PolyglotComponentProps, withPolyglot } from '../../../i18n';
import ValidationUtil from '../../../util/ValidationUtil';
import ErrorText from '../../commons/ErrorText';
const initialValues = {
  email: '',
  password: '',
  keepLogin: false,
};
export type LoginFromValues = typeof initialValues;
interface LoginFromProps extends PolyglotComponentProps {
  validationUtil: ValidationUtil;
  onSubmit: (values: LoginFromValues) => Promise<unknown>;
}

export function LoginForm(props: LoginFromProps) {
  const { polyglot, onSubmit, validationUtil } = props;
  const formik = useFormik({
    initialValues,
    validate: (values) => {
      const errors: Record<string, string> = {};
      const valid = validationUtil.validateEmailAddress(values.email, true);
      if (!valid) {
        errors.email = validationUtil.getErrorMessage('email');
      }
      return errors;
    },
    onSubmit: async (values, helpers) => {
      await onSubmit(values);
      helpers.setSubmitting(false);
    },
  });

  return (
    <Box
      sx={{
        width: '100%', // Fix IE 11 issue.
        marginTop: (theme) => theme.spacing(3),
        padding: (theme) => theme.spacing(2),
      }}
    >
      <form onSubmit={formik.handleSubmit} noValidate>
        <Stack spacing={2}>
          <TextField
            fullWidth
            id="email"
            name="email"
            type="email"
            label={polyglot.t('login.email')}
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={
              formik.touched.email &&
              formik.errors.email && (
                <ErrorText>{formik.errors.email}</ErrorText>
              )
            }
          />
          <TextField
            fullWidth
            id="password"
            name="password"
            label={polyglot.t('login.password')}
            type="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
            error={formik.touched.password && formik.values.password === ''}
          />
          <FormControlLabel
            control={
              <Checkbox
                value={formik.values.keepLogin}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                id="keepLogin"
                name="keepLogin"
                color="primary"
              />
            }
            label={polyglot.t('login.keep_login')}
          />
          <Button
            color="primary"
            variant="contained"
            fullWidth
            type="submit"
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? (
              <CircularProgress size={20} />
            ) : (
              polyglot.t('login.button_title')
            )}
          </Button>
        </Stack>
      </form>
    </Box>
  );
}

export default withPolyglot(LoginForm);
